import Vue from 'vue'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {
  required,
  maxLength,
  maxValue,
  minValue,
} from "vuelidate/lib/validators";
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import upLoad from "@/assets/img/upload_photo3.jpg";
import axios from "axios";
import store from "@/store";
import CONFIG from "@/assets/js/config.js";

const getTodayDateString = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export default {
  name: "paymentCreate",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading
  },
  data() {
    return {
      isSubmitted: false,
      config: CONFIG,
      imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
      paymentMethodArr: null,
      inputData: {
        class_id: "",
        student_id: "",
        guardian1_name: "",
        item_id: "",
        discount_type: null,
        discount_amount: null,
        discount_note: "",
        showDiscount: false,
        gross_total_amt: 0,
        net_total_amt: 0,
        quantity: 1,
      },
      paymentData: {
        class_id: "",
        student_id: "",
        guardian1_name: "",
        discount_type: null,
        discount_amount: null,
        gross_total_amt: 0,
        net_total_amt: 0,
        payment_method_id: "",
        payment_date: getTodayDateString(),
        enrollment_date: "",
        status: CONFIG.PAYMENT_STATUS.STATUS_APPROVED,
        due_date: "",
        receiver:
          store.state.user.name || localStorage.getItem("user_name") || "",
        remark: "",
        payment_screenshot: "",
        grade_id: "",
        acd_year_id: "",
      },
      paymentDetail: [],
      paymentHistory: [],
      ssImage: "",
      upLoad,
      classArr: [],
      addItem: false,
      submitted: false,
      campusId: store.state.user.campus_id,
      allStu: [],
      isLoading: false,
      disabled: false,
      guardian1Arr: [],
      guardian1Name: "",
      itemArr: [],
      itemId: null,
      visible: false,
      itemAmtArr: [],
      clonedOnce: false,
      disabledForm: false,
      discountPercent: "",
      discountFixAmount: "",
      discountError: "",
      paymentDiscountError: "",
      discountPercentageAmount: 0,
      submitting: false,
      taxRateValue: 0,
      maxQuantity: 999,
      academicYearArr: [],
      gradeArr: [],
      academicYearId: "",
      gradeId: "",
      serverErrors: {},
    };
  },

  validations() {
    const grossAmt = this.inputData.gross_total_amt || 0;
    const netTotalSum = this.netTotalSum || 0;

    const isValidDiscount = (value) =>
      value === null ||
      value === undefined ||
      (value >= 0 && value <= grossAmt);

    const isValidPaymentDiscount = (value) =>
      value === null ||
      value === undefined ||
      (value >= 0 && value <= netTotalSum);

    const isInteger = (value) =>
      value === null || value === undefined || Number.isInteger(Number(value));
    const isNonNegative = (value) =>
      value === null || value === undefined || Number(value) >= 0;
    const isPositiveInteger = (value) =>
      value === null || value === undefined || (Number.isInteger(Number(value)) && Number(value) > 0);
    const isValidSelectValue = (value) =>
      value !== null &&
      value !== undefined &&
      value !== "" &&
      Number(value) !== 0;

    const notFutureDate = (value) => {
      if (!value) return true;
      const today = getTodayDateString();
      return value <= today;
    };

    const notPastDate = (value) => {
      if (!value) return true;
      const today = getTodayDateString();
      return value >= today;
    };

    return {
      inputData: {
        class_id: {
          required,
        },
        student_id: {
          required,
        },
        item_id: {
          required,
        },
        gross_total_amt: {
          required,
        },
        net_total_amt: {
          required,
        },
        quantity: {
          required,
          isPositiveInteger,
          maxValue: maxValue(this.maxQuantity),
        },
        discount_amount: {
          isValidDiscount,
          isInteger,
        },
        discount_note: {
          maxLength: maxLength(1000),
        },
      },
      academicYearId: {
        required,
      },
      gradeId: {
        required,
      },
      paymentData: {
        class_id: {
          required,
        },
        student_id: {
          required,
        },
        gross_total_amt: {
          required,
        },
        discount_amount: {
          isValidPaymentDiscount,
          isInteger,
        },
        net_total_amt: {
          required,
          minValue: minValue(0),
        },
        receiver: {
          maxLength: maxLength(255),
        },
        status: {
          required,
        },
        due_date: {
          required,
          notPastDate,
        },
      },
      paymentHistory: {
        $each: {
          amount: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(999999999),
          },
          remark: { maxLength: maxLength(10000) },
          status: { required },
          payment_method_id: {
            required(value, parentVm) {
              if (
                Number(parentVm.status) ===
                CONFIG.PAYMENT_STATUS.STATUS_APPROVED
              ) {
                return isValidSelectValue(value);
              }

              return true;
            },
          },
          payment_date: {
            required(value, parentVm) {
              if (
                Number(parentVm.status) ===
                CONFIG.PAYMENT_STATUS.STATUS_APPROVED
              ) {
                return !!value;
              }

              return true;
            },
            notFutureDate,
          },
        },
      },
      discountPercent: { isNonNegative },
      discountFixAmount: { isNonNegative },
    };
  },

  methods: {
    getTodayDate() {
      return getTodayDateString();
    },
    sanitizePositiveInteger(value) {
      const matched = String(value ?? '').match(/-?\d+(\.\d+)?/);
      if (!matched) return 1;
      const parsed = Math.floor(Math.abs(Number(matched[0])));
      return isNaN(parsed) || parsed <= 0 ? 1 : parsed;
    },
    parseNumericInput(value) {
      const cleaned = String(value ?? "").replace(/[^\d.]/g, "");
      const parsed = parseFloat(cleaned);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    getServerError(field) {
      return this.serverErrors?.[field]?.[0] || "";
    },
    clearServerError(field) {
      if (!this.serverErrors?.[field]) {
        return;
      }
      const nextErrors = { ...this.serverErrors };
      delete nextErrors[field];
      this.serverErrors = nextErrors;
    },
    addPaymentHistory() {
      if (Number(this.totalAfterDiscount) <= 0) {
        this.isSubmitted = true;
        this.$notification.error("Total amount must be greater than 0.", {
          timer: 3,
          position: "bottomCenter",
        });
        this.isSubmitted = false;
        return;
      }
      if (this.paymentHistory.length === 0) {
        this.paymentHistory.push({
          amount: this.totalAfterDiscount,
          payment_method_id: null,
          status: this.paymentData.status,
          payment_date: this.getTodayDate(),
          remark: "",
        });
        this.submitted = false;
        return;
      }
      let currentPaid = this.paymentHistory.reduce(
        (sum, h) => sum + parseFloat(h.amount || 0),
        0,
      );
      let balance = this.totalAfterDiscount - currentPaid;

      this.paymentHistory.push({
        amount: balance > 0 ? balance : 0,
        payment_method_id: null,
        status: this.paymentData.status,
        payment_date: this.getTodayDate(),
        remark: "",
        image: null,
      });
      this.submitted = false;
    },

    removeHistory(index) {
      this.paymentHistory.splice(index, 1);
    },

    triggerUpload(index) {
      document.getElementById("fileInput" + index).click();
    },

    historyImgUpload(event, index) {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 2097152) {
          this.$notification.error(this.imageLargeMsg);
          return;
        }

        this.$set(this.paymentHistory[index], "image", file);
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$set(
            this.paymentHistory[index],
            "previewImage",
            e.target.result,
          );
        };
        reader.readAsDataURL(file);
      }
    },

    removeHistoryImg(index) {
      this.$set(this.paymentHistory[index], "previewImage", null);
      this.paymentHistory[index].image = null;
      const input = document.getElementById("fileInput" + index);
      if (input) input.value = "";
    },

    initDefaultHistory() {
      if (this.paymentHistory.length === 0) {
        this.addPaymentHistory();
      }
    },

    handleStatusChange() {
      const statusApproved = CONFIG.PAYMENT_STATUS.STATUS_APPROVED;

      if (Number(this.paymentData.status) !== statusApproved) {
        this.paymentHistory = [];
      } else {
        if (this.paymentHistory.length === 0) {
          this.addPaymentHistory();
        }
      }
    },
    resetInputData() {
      const preservedValues = {
        class_id: this.inputData.class_id,
        student_id: this.inputData.student_id,
        guardian1_name: this.inputData.guardian1_name,
      };
      this.inputData = {
        ...preservedValues,
        item_id: "",
        discount_type: null,
        discount_amount: null,
        discount_note: "",
        showDiscount: false,
        gross_total_amt: 0,
        net_total_amt: 0,
        quantity: 1,
      };
    },

    toggleDiscount() {
      this.inputData.showDiscount = !this.inputData.showDiscount;
      if (!this.inputData.showDiscount) {
        this.inputData.discount_amount = 0;
        this.inputData.discount_type = null;
        this.inputData.discount_note = "";
        this.discountError = "";
        this.calculateNetTotal();
      }
    },

    getItem(acdYearId) {
      if (!acdYearId || acdYearId == '' || acdYearId === 0) {
        return;
      }
      // SMS package - use getItemForPayment API (ignoring acdYearId from Prime structure)
      axios
        .get("item/getItemForPayment", {
          params: { acd_year_id: acdYearId },
        })
        .then((res) => {
          // Map to {id, text} format for Select2 display
          this.itemArr = (res.data.data || []).map(item => ({
            id: item.id,
            text: item.item_name || item.p_item_name || item.name || item.text || String(item)
          }));
          this.itemAmtArr = res.data.data;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
        });
    },

    getAmt(item_id) {
      var selectedItem = (this.itemAmtArr || []).find(
        (item) => item && item.id == item_id,
      );
      if (!selectedItem) {
        this.inputData.net_total_amt = 0;
        this.inputData.gross_total_amt = 0;
        return;
      }
      const quantity = this.sanitizePositiveInteger(this.inputData.quantity);
      this.inputData.net_total_amt = selectedItem.p_item_amount * quantity;
      this.inputData.gross_total_amt = selectedItem.p_item_amount * quantity;
    },

    getPaymentMethod() {
      axios
        .get("getPaymentMethod")
        .then((res) => {
          const raw = Array.isArray(res.data) ? res.data : res.data?.data || [];
          const formattedData = raw.map((item) => ({
            id: Number(item.id),
            text: item.text || item.payment_method || "",
          }));
          let $defaultSelectOption = [{ id: 0, text: "Select Payment Method" }];
          this.paymentMethodArr = $defaultSelectOption.concat(formattedData);
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.isLoading = false;
        });
    },

    isNumber(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;

        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },

    calculateNetTotalForDetail(item) {
      // Enforce minimum quantity of 1
      if (!item.quantity || Number(item.quantity) < 1) {
        item.quantity = 1;
      }
      // Enforce maximum quantity
      if (Number(item.quantity) > this.maxQuantity) {
        item.quantity = this.maxQuantity;
      }
      const quantity = this.sanitizePositiveInteger(item.quantity);
      const selectedItem = (this.itemAmtArr || []).find(
        (i) => i && i.id == item.item_id,
      );
      const baseAmount = selectedItem ? selectedItem.p_item_amount * quantity : 0;
      item.gross_total_amt = baseAmount;

      let discountAmount = this.parseNumericInput(item.discount_amount);

      if (item.discount_type == 1) {
        if (item.gross_total_amt != 0 && discountAmount > item.gross_total_amt) {
          discountAmount = 0;
        }
        item.net_total_amt = item.gross_total_amt - discountAmount;
      } else if (item.discount_type == 2) {
        if (discountAmount > 100) {
          discountAmount = 100;
        }
        const discount = (item.gross_total_amt * discountAmount) / 100;
        item.net_total_amt = item.gross_total_amt - discount;
      } else {
        item.net_total_amt = item.gross_total_amt;
      }
      if (item.net_total_amt < 0) item.net_total_amt = 0;
    },

    calculateNetTotal() {
      // Enforce minimum quantity of 1
      if (!this.inputData.quantity || Number(this.inputData.quantity) < 1) {
        this.inputData.quantity = 1;
      }
      // Enforce maximum quantity
      if (Number(this.inputData.quantity) > this.maxQuantity) {
        this.inputData.quantity = this.maxQuantity;
      }
      let discountAmount = this.parseNumericInput(
        this.inputData.discount_amount,
      );
      this.discountError = "";
      if (discountAmount < 0) {
        this.discountError = "Discount amount cannot be negative.";
        discountAmount = 0;
      }
      const quantity = this.sanitizePositiveInteger(this.inputData.quantity);
      const selectedItem = (this.itemAmtArr || []).find(
        (item) => item && item.id == this.inputData.item_id,
      );
      const baseAmount = selectedItem ? selectedItem.p_item_amount * quantity : 0;
      this.inputData.gross_total_amt = baseAmount;

      if (this.inputData.discount_type == 1) {
        if (
          this.inputData.gross_total_amt != 0 &&
          discountAmount > this.inputData.gross_total_amt
        ) {
          this.discountError = "Discount amount cannot exceed gross total.";
          discountAmount = 0;
        }
        this.inputData.net_total_amt =
          this.inputData.gross_total_amt - discountAmount;
      } else if (this.inputData.discount_type == 2) {
        if (discountAmount > 100) {
          this.inputData.discount_amount = 100;
        }
        const discount =
          (this.inputData.gross_total_amt * discountAmount) / 100;
        this.inputData.net_total_amt =
          this.inputData.gross_total_amt - discount;
      } else {
        this.inputData.net_total_amt = this.inputData.gross_total_amt;
      }
      if (this.inputData.net_total_amt < 0) this.inputData.net_total_amt = 0;
    },
    onItemChange() {
      this.getAmt(this.inputData.item_id);
      this.calculateNetTotal();
    },

    removeImg() {
      this.ssImage = "";
      document.getElementById("image").value = "";
    },

    getStudent(id) {
      this.inputData.student_id = null;
      this.inputData.guardian1_name = null;
      axios
        .get("student/getallStudent", {
          params: { campus_id: this.campusId, class_id: id },
        })
        .then((res) => {
          let $defaultSelectOption = [
            {
              id: 0,
              text: "Select",
            },
          ];
          this.allStu = $defaultSelectOption.concat(res.data);
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.isLoading = false;
        });
    },

    getGuardian1Name(id) {
      this.inputData.guardian1_name = null;
      axios
        .get("student/getGuardian1Name", {
          params: { campus_id: this.campusId, student_id: id },
        })
        .then((res) => {
          let $defaultSelectOption = [
            {
              id: 0,
              text: "Select Guardian 1 Name",
            },
          ];
          this.guardian1Arr = $defaultSelectOption.concat(res.data);
          if (res.data.length > 0) {
            this.inputData.guardian1_name = res.data[0].id;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.isLoading = false;
        });
    },

    imgUpload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return null;
      } else {
        if (e.target.files[0].type.includes("image/")) {
          if (e.target.files[0].type == "image/gif") {
            this.$notification.error("File not supported!", {
              timer: 3,
              position: "bottomCenter",
            });
            return null;
          }
          let reader = new FileReader();
          reader.onload = (e) => {
            if (e.target.result.length > 5242880) {
              this.$notification.error(this.imageLargeMsg, {
                timer: 3,
                position: "bottomCenter",
              });
            } else {
              this.ssImage = e.target.result;
              document.getElementById("image").value = "";
            }
          };
          reader.readAsDataURL(files[0]);
        } else {
          this.$notification.error("File not supported!", {
            timer: 3,
            position: "bottomCenter",
          });
          return null;
        }
      }
    },

    addEditData() {
      this.paymentDetail.push(Vue.util.extend({}, this.editData));
      this.editData = [];
    },

    addData() {
      if (this.editData.item_id) {
        this.paymentDetail.push(Vue.util.extend({}, this.inputData));
      }
    },

    formatDiscountAmount(amount) {
      return amount ? this.$options.filters.numFormat(amount) : "_";
    },

    checkDiscountType(discount_amount, discount_type) {
      if (discount_amount <= 0) {
        return "_";
      }
      return discount_type == 1 ? "Fixed" : "Percentage";
    },

    reset() {
      this.addItem = false;
      if (this.editData.item_id != null) {
        this.addEditData();
      }
      if (this.paymentDetail.length == 0) {
        this.getStudent(0);
        this.getGuardian1Name(0);
        this.inputData = {};
      } else {
        this.resetInputData();
      }
    },

    cloneForm() {
      this.editData = [];
      this.addItem = true;
      if (
        this.$v.inputData.$invalid ||
        this.$v.academicYearId.$invalid ||
        this.$v.gradeId.$invalid ||
        this.inputData.student_id == 0 ||
        this.discountError != ""
      ) {
        return;
      }
      this.cloneData();
    },

    cloneData() {
      if (this.paymentDetail.length < 20) {
        if (this.paymentDetail.length == 0 && !this.clonedOnce) {
          // Only clone once
          this.paymentDetail.push(Vue.util.extend({}, this.inputData));
          const student = this.allStu.find(
            (stu) => stu.id == this.inputData.student_id,
          );
          this.paymentData.class_id = this.inputData.class_id;
          this.paymentData.student_id = this.inputData.student_id;
          this.paymentData.student_name = student ? student.text : "";
          this.paymentData.guardian1_name = this.guardian1Arr[1]
            ? this.guardian1Arr[1].text
            : "";
          this.disabledForm = true;
          this.clonedOnce = true;
        } else {
          const exists = this.paymentDetail.some(
            (detail) => detail.item_id == this.inputData.item_id,
          );

          if (!exists) {
            this.paymentDetail.push(Vue.util.extend({}, this.inputData));
          } else {
            this.$notification.error("Payment Item Is Already Exists.", {
              timer: 3,
              position: "bottomCenter",
            });
          }
        }
        this.resetInputData();
      } else {
        alert("Payment can be created at most 20.");
      }
      this.addItem = false;
      this.disabled = false;
    },

    removeClone(index) {
      Vue.delete(this.paymentDetail, index);
      if (this.paymentDetail.length == 0) {
        this.inputData = {
          class_id: "",
          student_id: "",
          guardian1_name: "",
          discount_type: null,
          item_id: "",
          gross_total_amt: 0,
          net_total_amt: 0,
          quantity: 1,
        };
        this.discountPercent = "";
        this.discountPercentageAmount = null;
        this.discountFixAmount = "";
        this.disabledForm = false;
        this.clonedOnce = false;
        this.academicYearId = "";
        this.gradeId = "";
      }
    },

    editClone(index) {
        const rowData = { ...this.paymentDetail[index] };
        const savedDiscountAmount = rowData.discount_amount;
        this.addData();
        this.getEditData(rowData);
        this.inputData = {
            ...rowData,
            showDiscount: !!rowData.discount_type,
        };
        if (!this.inputData.quantity || Number(this.inputData.quantity) < 1) {
          this.inputData.quantity = 1;
        }
        Vue.delete(this.paymentDetail, index);
        this.$nextTick(() => {
          this.inputData.discount_amount = savedDiscountAmount;
          this.calculateNetTotal();
        });
    },

    getEditData(data) {
      this.editData.class_id = data.class_id;
      this.editData.student_id = data.student_id;
      this.editData.guardian1_name = data.guardian1_name;
      this.editData.item_id = data.item_id;
      this.editData.discount_type = data.discount_type;
      this.editData.discount_amount = data.discount_amount;
      this.editData.discount_note = data.discount_note;
      this.editData.gross_total_amt = data.gross_total_amt;
      this.editData.net_total_amt = data.net_total_amt;
      this.editData.quantity = data.quantity;
    },

    submitPayment() {
      if (this.submitting) return;
      this.submitted = true;
      this.serverErrors = {};
      this.$v.$touch();
      const hasDueDateError = this.$v.paymentData.due_date.$invalid;

      if (this.paymentDetail.length === 0 && !hasDueDateError) {
        this.$notification.error(
          "Please add at least one payment item first.",
          {
            timer: 3,
            position: "bottomCenter",
          },
        );
        return;
      }

      const isFormInvalid = 
        this.$v.paymentData.$invalid || 
        this.$v.paymentHistory.$invalid;

      const safeHistories = Array.isArray(this.paymentHistory)
        ? this.paymentHistory.filter(Boolean)
        : [];

      const totalPaid = safeHistories.reduce(
        (sum, h) => sum + parseFloat(String(h.amount || 0).replace(/,/g, "")),
        0,
      );

      const requiredAmount = parseFloat(String(this.totalAfterDiscount || 0).replace(/,/g, ""));
      if (totalPaid > requiredAmount) {
        this.$notification.error("Total payment cannot exceed required amount.", {
          timer: 3,
          position: "bottomCenter",
        })
        return;
      }
      if (isFormInvalid) {
        return; 
      }
    
      this.submitting = true;
      this.isLoading = true;

      let formData = new FormData();
      const loginId = store.state.user.id || localStorage.getItem("user_id");
      const loginName = store.state.user.name || "Admin";
      const cleanAmount = (val) =>
        val == null ? "0" : String(val).replace(/,/g, "");

      formData.append("loginId", loginId);
      formData.append("paymentData[class_id]", this.paymentData.class_id);
      formData.append("paymentData[student_id]", this.paymentData.student_id);
      formData.append("paymentData[status]", this.paymentData.status);
      formData.append("paymentData[due_date]", this.paymentData.due_date);
      formData.append("paymentData[receiver]", this.paymentData.receiver);
      formData.append(
        "paymentData[net_total_amt]",
        cleanAmount(this.amountAfterGlobalDiscount),
      );
      formData.append(
        "paymentData[gross_total_amt]",
        cleanAmount(this.netTotalSum),
      );
      formData.append("paymentData[tax]", cleanAmount(this.taxAmount));
      formData.append(
        "paymentData[grand_total_amt]",
        cleanAmount(this.totalAfterDiscount),
      );
      formData.append(
        "paymentData[is_discount]",
        this.paymentData.is_discount ? 1 : 0,
      );

      if (this.paymentData.is_discount) {
        formData.append(
          "paymentData[discount_type]",
          this.paymentData.discount_type,
        );
        formData.append(
          "paymentData[discount_amount]",
          this.paymentData.discount_amount,
        );
      }

      this.paymentDetail.forEach((item, index) => {
        formData.append(`paymentDetail[${index}][item_id]`, item.item_id);
        formData.append(`paymentDetail[${index}][quantity]`, item.quantity);
        formData.append(
          `paymentDetail[${index}][gross_total_amt]`,
          cleanAmount(item.gross_total_amt),
        );
        formData.append(
          `paymentDetail[${index}][net_total_amt]`,
          cleanAmount(item.net_total_amt),
        );
        if (item.discount_amount) {
          formData.append(
            `paymentDetail[${index}][discount_type]`,
            item.discount_type,
          );
          formData.append(
            `paymentDetail[${index}][discount_amount]`,
            item.discount_amount,
          );
          formData.append(
            `paymentDetail[${index}][discount_note]`,
            item.discount_note || "",
          );
        }
      });

      if (safeHistories.length > 0) {
        safeHistories.forEach((item, index) => {
          const isApproved = Number(item.status) === CONFIG.PAYMENT_STATUS.STATUS_APPROVED;
          formData.append(`history[${index}][amount]`, cleanAmount(item.amount));

          if (isApproved) {
            const pId = item.payment_method_id;
            if (pId !== null && pId !== undefined && pId !== "" && pId !== 0 && pId !== "0" && pId !== "null") {
              formData.append(`history[${index}][payment_method_id]`, Number(pId));
            }
          }

          formData.append(`history[${index}][status]`, item.status);
          formData.append(`history[${index}][remark]`, item.remark || "");
          formData.append(`history[${index}][receiver]`, loginName);
          if (item.image) {
            if (item.image instanceof File) {
              formData.append(`history[${index}][screenshot]`, item.image);
            } else if (typeof item.image === 'string' && item.image.startsWith('data:')) {
              formData.append(`history[${index}][screenshot]`, item.image);
            }
          }
        });
      }

      axios
        .post("payment/submit", formData)
        .then((res) => {
          if (res.data.success === true) {
            this.$notification.success("Payment Added Successfully", {
              timer: 3,
              position: "bottomCenter",
            });
            this.$router.push({ name: "paymentList" });
          }
        })
        .catch((err) => {
          if (err?.response?.status === 422) {
            this.serverErrors = err.response.data.errors; 
            return; 
          }
          const message =
            err?.response?.data?.message ||
            (err?.response?.data?.errors
              ? Object.values(err.response.data.errors).flat().join("\n")
              : "");
          if (message) {
            this.$notification.error(message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.submitting = false;
        });
    },
    back() {
      this.$router.go(-1);
    },

    getAcademicYears() {
      axios.get("period/periodList")
      .then((res) => {
        let $defaultSelectOption = [{
          'id': 0,
          'text': 'Select Academic Year'
        }];
        const periods = res.data?.data || res.data || [];
        this.academicYearArr = $defaultSelectOption.concat(Array.isArray(periods) ? periods : []);
      }).catch(err => {
        console.error("Error fetching academic years:", err);
        this.academicYearArr = [{ id: 0, text: "Select Academic Year" }];
      });
    },

    getGradesByYear(yearId) {
      this.gradeArr = [{ id: 0, text: "Select Grade" }];
      this.gradeId = "";
      if (!yearId || yearId == 0) return;
      axios
        .get("getGradeNameByAcademicYear", {
          params: { id: yearId, campus_id: this.campusId },
        })
        .then((res) => {
          let $defaultSelectOption = [{ id: 0, text: "Select Grade" }];
          this.gradeArr = $defaultSelectOption.concat(res.data);
        }).catch(err => {
          console.error("Error fetching grades:", err);
        });
    },

    getClassesByGrade(gradeId) {
      this.classArr = [{ id: 0, text: "Select Class" }];
      this.inputData.class_id = "";
      this.inputData.student_id = "";
      this.allStu = [{ id: 0, text: "Select" }];
      if (!gradeId || gradeId == "") return;
      axios
        .get("class/getSection/" + gradeId, {
          params: {
            academic_year: this.academicYearId,
            campus_id: store.state.user.campus_id
          }
        })
        .then((res) => {
          let $defaultSelectOption = [{ id: 0, text: "Select Class" }];
          this.classArr = $defaultSelectOption.concat(res.data[0]);
        }).catch(err => {
          console.error("Error fetching classes:", err);
        });
    },
    //override original method
    getClass() {
    },

    getTaxRate() {
      axios.get(`setting/${store.state.user.campus_id}`)
        .then(res => {
          const raw = parseFloat(res.data?.tax_rate ?? 0);
          this.taxRateValue = Number.isFinite(raw) ? raw / 100 : 0;
        })
        .catch(err => {
          console.log(err);
          this.taxRateValue = 0;
        });
    },
  },

  watch: {
    "inputData.discount_amount": function (newVal) {
      if (!newVal) {
        this.inputData.net_total_amt = this.inputData.gross_total_amt;
        return;
      }
      let cleanValue = String(newVal).replace(/[^\d.]/g, "");
      
      if (String(newVal) !== cleanValue) {
        this.inputData.discount_amount = cleanValue;
      }

      let numericVal = parseFloat(cleanValue) || 0;
      let grossTotal = parseFloat(this.inputData.gross_total_amt) || 0;

      if (this.inputData.discount_type == 1) { 
        let fixed = Math.min(numericVal, grossTotal);
        this.inputData.net_total_amt = grossTotal - fixed;
      } else if (this.inputData.discount_type == 2) {
        let percent = Math.min(numericVal, 100);
        this.inputData.net_total_amt = grossTotal - (grossTotal * percent / 100);
      }
      if (this.inputData.net_total_amt < 0) this.inputData.net_total_amt = 0;
    },
    discountPercent(val) {
      if (val !== "") {
        this.discountFixAmount = "";
      } else {
        this.discountPercentageAmount = 0;
      }
    },
    discountFixAmount(val) {
      if (val !== "") {
        this.discountPercent = "";
      }
    },
    "inputData.discount_type"(newVal) {
        if (newVal == null) {
            this.inputData.discount_amount = null;
            this.inputData.net_total_amt = this.inputData.gross_total_amt;
            this.discountError = "";
        }
    },
    totalAfterDiscount(newVal) {
      if (this.paymentHistory.length === 1) {
        this.paymentHistory[0].amount = newVal;
      }
    },
    "paymentData.status"(newVal) {
      if (newVal == CONFIG.PAYMENT_STATUS.STATUS_APPROVED) {
        if (this.paymentHistory.length === 0) {
          this.addPaymentHistory();
        }
        if (this.paymentHistory[0]) {
          this.paymentHistory[0].amount = this.totalAfterDiscount;
          this.paymentHistory[0].payment_date = this.getTodayDate();
        }
      } else if (newVal == CONFIG.PAYMENT_STATUS.STATUS_ADMIN_REQUEST) {
        this.paymentData.payment_date = null;
        this.paymentHistory = [];
      }
    },
    academicYearId(val) {
      if (!val || val == '' || val === 0) {
        return;
      }
      this.getGradesByYear(val);
      this.getItem(val);
      this.getClass();
    },
    gradeId(val) {
      this.getClassesByGrade(val);
    },
    paymentHistory: {
      deep: true,
      handler(value) {
        const statusApproved = CONFIG.PAYMENT_STATUS.STATUS_APPROVED;
        (value || []).forEach((history) => {
          if (Number(history.status) !== statusApproved) {
            if (history.payment_method_id !== null) {
              history.payment_method_id = null;
            }
          }
        });
      },
    },
  },

  computed: {
    taxRate() {
      return this.taxRateValue || 0;
    },
    netTotalSum() {
      return this.paymentDetail.reduce(
        (sum, item) => sum + (parseFloat(item.net_total_amt) || 0),
        0,
      );
    },
    globalDiscountAmount() {
      this.paymentDiscountError = "";
      if (this.discountPercent < 0 || this.discountFixAmount < 0) {
        this.paymentDiscountError = "Discount amount cannot be negative.";
      }
      let currentNetTotalSum = this.netTotalSum;
      let discountAmount = 0;
      if (this.discountPercent) {
        if (this.discountPercent > 100) {
          this.discountPercent = 100;
        }
        this.paymentData.is_discount = 1;
        this.paymentData.discount_type = 2;
        discountAmount = (currentNetTotalSum * this.discountPercent) / 100;
      } else if (this.discountFixAmount) {
        this.paymentData.is_discount = 1;
        this.paymentData.discount_type = 1;
        discountAmount = Number(this.discountFixAmount);
      } else {
        this.paymentData.is_discount = 0;
        this.paymentData.discount_type = null;
        discountAmount = 0;
      }
      this.paymentData.discount_amount = discountAmount;
      return discountAmount;
    },
    amountAfterGlobalDiscount() {
      let result = this.netTotalSum - this.globalDiscountAmount;
      return result > 0 ? result : 0;
    },
    taxAmount() {
      const tax = Math.round(this.amountAfterGlobalDiscount * this.taxRate);
      this.paymentData.tax = tax;
      return tax;
    },
    totalAfterDiscount() {
      return this.amountAfterGlobalDiscount + this.taxAmount;
    },

    paymentOptions() {
      return CONFIG.PAYMENT_STATUSES_OPTIONS.filter((opt) =>
        [
          CONFIG.PAYMENT_STATUS.STATUS_APPROVED,
          CONFIG.PAYMENT_STATUS.STATUS_ADMIN_REQUEST,
        ].includes(opt.id),
      );
    },
    isApproveStatus() {
      return (
        Number(this.paymentData.status) ===
        this.config.PAYMENT_STATUS.STATUS_APPROVED
      );
    },
    isAddButtonDisabled() {
      return (
        this.isLoading ||
        this.submitting ||
        this.paymentDetail.length === 0 ||
        Number(this.totalAfterDiscount) <= 0
      );
    },
  },
  mounted() {
    this.isLoading = true;
    this.paymentData.receiver = store.state.user?.name || this.paymentData.receiver;
    this.paymentData.payment_date = new Date().toISOString().slice(0, 10);
    this.getAcademicYears();
    this.getPaymentMethod();
    this.getTaxRate();
    this.getClass();
    this.getItem();
    this.isLoading = false;
  },
};
